/**
 * Catálogo de tareas del embudo para el alta manual CRM.
 * Fallback si GET /leads/flujo-catalogo no responde; el backend es la fuente de verdad.
 *
 * T3 · Agendar cita SÍ está en el diagrama (M1 → cita). En alta manual, TC/T3/T3AE
 * abren ModalCita ANTES de guardar el lead (si cancelan, no se crea nada).
 */
export const ALTA_MANUAL_TASKS_REQUIEREN_CITA = ["TC", "T3", "T3AE"];

export function taskRequiereCitaAntesDeAlta(code) {
  return ALTA_MANUAL_TASKS_REQUIEREN_CITA.includes(String(code || "").trim().toUpperCase());
}

/** Solo estas 3 en el desplegable «Asignar tarea» del alta manual (Nuevo lead). */
export const ALTA_MANUAL_TASK_OPTIONS = [
  { code: "T1", label: "T1 · Llamada inicial" },
  { code: "T1C", label: "T1c · Enviar WhatsApp" },
  { code: "TC", label: "T4 · Cita" },
];

export const LEAD_FLOW_TASK_OPTIONS_FALLBACK = [
  { code: 'T1', label: 'T1 · Llamada inicial' },
  { code: 'T1R', label: 'T1 · Llamada (cliente existente)' },
  { code: 'T1B', label: 'T1b · 2ª llamada' },
  { code: 'T1C', label: 'T1c · Mandar un WhatsApp' },
  { code: 'T2A', label: 'T2A · Cualificar' },
  { code: 'T2L', label: 'T2L · Volver a llamar' },
  { code: 'T2B', label: 'T2b · Seguimiento sin cita' },
  { code: 'T2E', label: 'T3b · Enviar propiedad por WhatsApp' },
  { code: 'T3', label: 'T3 · Agendar cita' },
  { code: 'T3B', label: 'T3b · WhatsApp al lead' },
  { code: 'T3B1', label: 'T3b1 · WhatsApp al lead' },
  { code: 'T3BN', label: 'T3bN · Buscar propiedad' },
  { code: 'T3AE', label: 'Agendar cita tras envío automático' },
  { code: 'TC', label: 'T4 · Cita' },
  { code: 'T4', label: 'Cualificar cita' },
  { code: 'T4B1', label: 'T4b1 · Llamada o WhatsApp al cliente' },
  { code: 'T4B2', label: 'T4b2 · Enviar WhatsApp al cliente' },
  { code: 'T4B3', label: 'T4b3 · Enviar propiedad' },
  { code: 'T4BN', label: 'T4bN · Buscar propiedad' },
  { code: 'T7', label: 'T7 · Venta' },
];
